// extracted by mini-css-extract-plugin
export default {"orgsSelector":"CopyCheckedSelector_orgsSelector__8ScCO","placeHolderShimmer":"CopyCheckedSelector_placeHolderShimmer__fk8IE"};